<template>
  <div
    v-show="visible"
    :class="['m-bubble-cont',{
      'drag-container': maskVisible
    }]"
  >
    <div
      v-if="bubble"
      ref="ball"
      class="m-bubble-ball-wrap"
      :class="{
        releft: releft
      }"
      :style="{
        height: `${height / 12}rem`,
        left: posX + 'px',
        top: posY === 'auto' ? posY : posY + 'px'
      }"
      @touchstart.stop="touchstart"
      @touchmove.stop.prevent="touchmove"
      @touchend.stop="touchend"
    >
      <a
        class="m-bubble-ball"
        :style="{ height: `${height / 12}rem` }"
        :href="bubble.href"
      >
        <img
          :style="{height: `${height / 12}rem`}"
          :src="bubble.image"
          alt=""
        >
        <!-- line wrap  fade_out -->
        <div
          v-if="showDefault"
          class="line-wrap"
        >
          <!-- line con  slide_left -->
          <div class="line-con">
            <!-- img -->
            <img
              v-if="showDefault && bubble.flagText"
              :src="bubble.flagText"
              class="line"
              alt=""
            >
            <!-- text -->
            <div
              v-if="bubble.text"
              class="line-text-wrap"
            >
              <p class="tw-line-clamp-2">{{ bubble.text }}</p>
            </div>
          </div>

        </div>
      </a>

      <div
        class="m-bubble-close"
        @click="handleClose"
      >
        <img
          src="../images/close.png"
          alt="close"
        >
      </div>
    </div>

    <template v-if="popupAd && dialogVisible && visible">
      <div
        v-if="popVisible"
        class="m-bubble-ball-pop-mask"
      />
      <PopupAd
        :href="popupAd.href"
        :image="popupAd.image"
        :text="popupAd.name || popupAd.text"
        :class="['bubble-popup-wrap',{'popup-scale':!popVisible}]"
        @close="handleClosePop"
      />
    </template>
  </div>
</template>

<script>
import eventBus from '@ms/utils/event-bus.js'
import PopupAd from 'wap/components/PushPopup/pagelet/PopupAd'

export default {
  name: 'BubbleBall',
  components: {
    PopupAd
  },
  props: {
    bubble: {
      type: Object,
      default: null
    },
    popupAd: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      height: 0,
      el: null,
      oL: 0,
      oT: 0,
      maxW: 0,
      maxH: 0,
      releft: false,
      left: 10,
      posX: 10,
      posY: 'auto',
      maskVisible: false,
      showDefault: true,
      popVisible: true,
      dialogVisible: true
    }
  },
  mounted() {
    this.setBallTop()
    if (this.bubble) {
      this.renderImage()
      const line = localStorage.getItem('PROMO_CALENDAR_URL')
      this.showDefault = line !== this.bubble.href
      localStorage.setItem('PROMO_CALENDAR_URL', this.bubble.href)
    } else {
      this.visible = true
    }
    eventBus.$on('popup_ad_close', () => {
      this.popVisible = false
      this.dialogVisible = false
    })

    eventBus.$on('bubbleBall_move', this.setBallTop)
  },
  deactivated() {
    this.reset()
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    reset() {
      eventBus.$off('popup_ad_close')
      eventBus.$off('bubbleBall_move')
    },
    renderImage() {
      const img = new Image()
      img.onload = () => {
        this.visible = true
        // 2x 图
        this.height = img.height / 2
        this.$nextTick(() => {
          this.move()
        })
      }
      img.src = this.bubble.image
    },
    move() {
      if (!this.$refs.ball) return
      this.el = this.$refs.ball
      this.maxW = document.documentElement.clientWidth - this.el.offsetWidth
      this.maxH = document.documentElement.clientHeight - this.el.offsetHeight
      this.left = this.el.offsetLeft
    },
    touchstart(e) {
      const touch = e.targetTouches[0]
      this.oL = touch.clientX - this.el.offsetLeft
      this.oT = touch.clientY - this.el.offsetTop
      this.maskVisible = true
    },
    touchmove(e) {
      const touch = e.targetTouches[0]
      let oLeft = touch.clientX - this.oL
      let oTop = touch.clientY - this.oT
      if (oLeft < 0) {
        oLeft = 0
      } else if (oLeft >= this.maxW) {
        oLeft = this.maxW
      }
      if (oTop < 0) {
        oTop = 0
      } else if (oTop >= this.maxH) {
        oTop = this.maxH
      }

      this.posX = oLeft
      this.posY = oTop
    },
    touchend() {
      this.maskVisible = false
      this.checkPosition()
    },
    checkPosition() {
      // 松手吸附到左侧
      this.releft = true
      this.posX = this.left
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.releft = false
      }, 300)
    },
    handleClose() {
      this.visible = false
    },
    setBallTop() {
      const topEl = document.querySelector('.section-round') // 获取live区域
      if (topEl) {
        const casinoGames = document.querySelector('.m-casino-games')
        const featured = document.querySelector('.m-featured')
        // 有游戏卡片和焦点比赛时，浮标在焦点比赛卡片左上方；没有游戏卡片有焦点赛事则 浮标在live上，没有则在live下（market下方）
        let add
        if (casinoGames && featured) {
          add = -165
        } else {
          add = featured ? -42 : 82
        }
        const dur = topEl.offsetTop + add
        const dey = document.documentElement.clientHeight - dur
        if (dey > 50) this.posY = dur // 在首屏可视区域则定位到该位置，不在则默认距离顶部20
      }
    },
    handleClosePop() {
      this.popVisible = false
      const { bubble, popupAd } = this
      if (!bubble || popupAd.text !== 'popUptoBox') {
        // 判断浮标和广告位是否有联系
        this.dialogVisible = false // 无联系直接关闭
      } else {
        // 有联系
        const el = this.$refs.ball // 获取浮标
        const windowHeight = document.documentElement.clientHeight
        const winW = document.documentElement.clientWidth
        const pop = document.querySelector('.m-popup-ad-wrap') // 广告位元素

        const midT = windowHeight / 2 // 中心点也就是广告位中心点
        const midL = winW / 2

        const top = el.offsetTop - midT + 30 // 浮标与广告位的纵向距离(y)，30只是为了让他在浮标内
        const left = el.offsetLeft - midL + 25 // 浮标与广告位的横向距离(x)

        let speed = 100
        const top1 = top / speed // 每次前进单位
        const left1 = left / speed

        let t = midT
        let l = midL

        const _timer = setInterval(() => {
          speed--
          t += top1
          l += left1
          pop.style.top = t + 'px'
          pop.style.left = l + 'px'
          if (speed <= 0) {
            clearInterval(_timer)
            this.dialogVisible = false
          }
        }, 3)
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/mixin.less");

.drag-container {
  position: fixed;
  z-index: 1001;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  touch-action: none;
}

.m-bubble-ball-wrap {
  position: fixed;
  z-index: 1001;
  bottom: 20/@rem;
  left: 10/@rem;
  user-select: none;

  &.releft {
    transition: left 0.3s linear;
  }
}

.m-bubble-ball {
  position: relative;
  display: block;

  img {
    display: block;

    &.line {
      height: 32/@rem;
    }
  }

  .line-wrap {
    position: absolute;
    z-index: -1;
    bottom: 0;
    left: 35/@rem;
    display: flex;
    overflow: hidden;
    height: 32/@rem;
    align-items: flex-end;
    animation: fade_out 0.8s 2.3s ease-in-out forwards;
  }

  .line-con {
    position: relative;
    animation: slide_left 0.8s 2s ease-in-out forwards;
  }

  .line-text-wrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    align-items: center;
    padding: 5/@rem 10/@rem 5/@rem 20/@rem;
    margin: auto;
    color: @dark;
    font-size: 10/@rem;
    font-weight: bold;
  }

  @keyframes slide_left {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-100%);
    }
  }

  @keyframes fade_out {
    from {
      width: 106/@rem;
    }

    to {
      width: 0;
    }
  }
}

.m-bubble-ball-pop-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 70%);
}

.bubble-popup-wrap {
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  margin: auto;
  transform: translate(-50%, -50%);
  transform-origin: center;
}

.popup-scale {
  animation: backBubble 0.3s forwards;
}

.m-bubble-close {
  position: absolute;
  z-index: 1;
  top: -2px;
  right: -2px;

  img {
    height: 12px;
    vertical-align: top;
  }
}

@keyframes backBubble {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  99% {
    opacity: 0.7;
    transform: translate(-50%, -50%) scale(0.1);
  }

  100% {
    opacity: 0.1;
    transform: translate(-50%, -50%) scale(0.01);
  }
}

</style>
